const checkoutStage = require('../checkout/checkoutStage');
const modals = require('../components/modals');
const { default: getFrontConfig } = require('../common/getFrontConfig');

const FRONT_CONFIG = getFrontConfig();

const MODAL_CLASS = 'store-stock-changed-modal';
const CHANGE_STORE_BUTTON_CLASS = `${MODAL_CLASS}__change-store-button`;
const PLACE_ORDER_BUTTON_CLASS = `${MODAL_CLASS}__place-order-button`;

/**
 * Logic to do after clicking the store stock changed modal change store button
 * Go to SHIPPING_ADDRESS checkout step & close modal
 */
function handleChangeStoreButtonEvent() {
  checkoutStage.methods.setStage(checkoutStage.stages.SHIPPING_ADDRESS);
  removeEventListeners();
  const modalElement = document.querySelector(`.${MODAL_CLASS}`);
  modals.closeModal($(modalElement));
}

/**
 * Logic to do after clicking the store stock changed modal place order button
 * Remove unavailable products from cart & send them to wishlist,
 * then reload page to force the checkout data update
 */
function handlePlaceOrderButtonClick() {
  const placeOrderButtonElement = document.querySelector(`.${PLACE_ORDER_BUTTON_CLASS}`);
  if (!placeOrderButtonElement) {
    return;
  }
  const url = placeOrderButtonElement.dataset.href;
  fetch(url, {
    method: 'POST',
  })
    .then((response) => response.json())
    .then((response) => {
      $('body').trigger('checkout:updateCheckoutView', {
        order: response.order,
        customer: response.customer,
      });
      checkoutStage.methods.setStage(checkoutStage.stages.PAYMENT_METHOD);

      removeEventListeners();
      const modalElement = document.querySelector(`.${MODAL_CLASS}`);
      modals.closeModal($(modalElement));
    });
}

/**
 * Remove event listeners for the store stock changed modal
 */
function removeEventListeners() {
  window.removeEventListener('resize', handlePlaceOrderButtonStyles);
  window.removeEventListener('resize', handleChangeStoreButtonStyles);
  const changeStoreButtonElement = document.querySelector(`.${CHANGE_STORE_BUTTON_CLASS}`);
  changeStoreButtonElement?.removeEventListener('click',
    handleChangeStoreButtonEvent);
  const placeOrderButtonElement = document.querySelector(`.${PLACE_ORDER_BUTTON_CLASS}`);
  placeOrderButtonElement?.removeEventListener('click',
    handlePlaceOrderButtonClick);
}

/**
 * Change the place order button styles depending on the device width
 */
function handlePlaceOrderButtonStyles() {
  const placeOrderButtonElement = document.querySelector(`.${PLACE_ORDER_BUTTON_CLASS}`);
  if (!placeOrderButtonElement) {
    return;
  }

  const DESKTOP_CLASS = 'btn--primary';
  const MOBILE_CLASS = 'btn--round-black-mobile';

  if (window.innerWidth <= FRONT_CONFIG.responsive.bp_1025) {
    placeOrderButtonElement.classList.remove(DESKTOP_CLASS);
    placeOrderButtonElement.classList.add(MOBILE_CLASS);
  } else {
    placeOrderButtonElement.classList.remove(MOBILE_CLASS);
    placeOrderButtonElement.classList.add(DESKTOP_CLASS);
  }
}

/**
 * Change the change store button styles depending on the device width
 */
function handleChangeStoreButtonStyles() {
  const changeStoreButtonElement = document.querySelector(`.${CHANGE_STORE_BUTTON_CLASS}`);
  if (!changeStoreButtonElement) {
    return;
  }

  const placeOrderButtonElement = document.querySelector(`.${PLACE_ORDER_BUTTON_CLASS}`);
  const DESKTOP_CLASS = placeOrderButtonElement ? 'btn--text-italic' : 'btn--primary';
  const MOBILE_CLASS = placeOrderButtonElement ? 'btn--link' : 'btn--round-black-mobile';

  if (window.innerWidth <= FRONT_CONFIG.responsive.bp_1025) {
    changeStoreButtonElement.classList.remove(DESKTOP_CLASS);
    changeStoreButtonElement.classList.add(MOBILE_CLASS);
  } else {
    changeStoreButtonElement.classList.remove(MOBILE_CLASS);
    changeStoreButtonElement.classList.add(DESKTOP_CLASS);
  }
}

/**
 * Add event listeners for the store stock changed modal
 */
function addEventListeners() {
  window.addEventListener('resize', handlePlaceOrderButtonStyles);
  window.addEventListener('resize', handleChangeStoreButtonStyles);
  const changeStoreButtonElement = document.querySelector(`.${CHANGE_STORE_BUTTON_CLASS}`);
  changeStoreButtonElement?.addEventListener('click',
    handleChangeStoreButtonEvent);
  const placeOrderButtonElement = document.querySelector(`.${PLACE_ORDER_BUTTON_CLASS}`);
  placeOrderButtonElement?.addEventListener('click',
    handlePlaceOrderButtonClick);
}

/**
 * Initialize the store stock changed modal
 */
function init() {
  addEventListeners();
  handlePlaceOrderButtonStyles();
  handleChangeStoreButtonStyles();
}

module.exports = {
  init,
};
